import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { Breadcrumb, DataGridSetting } from "../../../../components";
import { Button, Alert } from "../../../../shared";
import { useUser } from "../../../../hooks/query";
import { useAuth } from "../../../../hooks";

import { columnDef } from "./column-def";

export default function List() {
    const { selectedOrganization } = useAuth();
    const { useList } = useUser();
    const { data, isLoading, isError, error } = useList();

    if (!selectedOrganization?.Id) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage="Select an organization to view users." />
            </Box>
        );
    }

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load users"}
                </Box>
            </Box>
        );
    }

    const users = (data as any[]) || [];

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={users}
                    columnDefs={columnDef}
                    quickControlStartDecorator={<CreateUserButton />}
                />
            </Box>
        </Box>
    );
}

function CreateUserButton() {
    return (
        <Box display="flex" alignItems={"center"} ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/admin/users/new"
                startDecorator={<Plus size={18} />}
            >
                New User
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
